import { NgModule } from '@angular/core';
import {NoPreloading, RouterModule, Routes} from '@angular/router';
import { ShellPagesComponent } from './shell-pages.component';
import { BACKOFFICE_ROUTERS } from './routes/backoffice-router';
import {CUSTOMER_ROUTERS} from "@modules/commom/shell-pages/routes/customer-router";
import { authCustomerGuard } from '../../../core/guards/auth-customer.guard';
import { NotAuthorizedComponent } from 'src/app/shared/components/auxiliary-page/not-authorized/not-authorized.component';
import { UnderConstructionComponent } from 'src/app/shared/components/auxiliary-page/under-construction/under-construction.component';
import { PARTNER_ROUTERS } from './routes/partner-router';
import {checkProfileGuard} from "../../../core/guards/check-profile.guard";
import {ProfileType} from "@variables/profileType";

const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: '',
    component: ShellPagesComponent,
    children: [
      ...CUSTOMER_ROUTERS,
      {
        path: 'cliente/nao-autorizado',
        component: NotAuthorizedComponent,
        canActivate: [checkProfileGuard],
        data: { profileAuthorized: [ProfileType.CUSTOMER, ProfileType.RELATIONSHIP, ProfileType.BACKOFFICE] },
      },
    ]
  },
  {
    path: 'backoffice',
    component: ShellPagesComponent,
    children: [
      ...BACKOFFICE_ROUTERS,
      {
        path: 'nao-autorizado',
        component: NotAuthorizedComponent,
        canActivate: [checkProfileGuard],
        data: { profileAuthorized: [ProfileType.BACKOFFICE] },
      },
    ]
  },
  {
    path: 'parceiro',
    component: ShellPagesComponent,
    children: [
      ...PARTNER_ROUTERS,
      {
        path: 'nao-autorizado',
        component: NotAuthorizedComponent,
        canActivate: [checkProfileGuard],
        data: { profileAuthorized: [ProfileType.PARTNER] },
      },
    ]
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: NoPreloading })],
  exports: [RouterModule]
})
export class ShellPagesRoutingModule { }
